import { render, staticRenderFns } from "./CompanyRightSection.vue?vue&type=template&id=06db4337&scoped=true"
import script from "./CompanyRightSection.vue?vue&type=script&lang=js"
export * from "./CompanyRightSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyRightSection.vue?vue&type=style&index=0&id=06db4337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db4337",
  null
  
)

export default component.exports